import React from "react";
import PropTypes from "prop-types";
import { FeedbackIcon } from "../FeedbackIcon";

const INPUT_TYPES = {
  TEXT: "text",
  NUMBER: "number",
};

export function InputCell(props) {
  const validate = (event) => {
    let value = null;
    if (props.type === INPUT_TYPES.TEXT) {
      value = event.target.value;
    }
    if (props.type === INPUT_TYPES.NUMBER) {
      const n = event.target.valueAsNumber;
      if (!Number.isFinite(n)) {
        value = "";
      } else {
        // Determine accuracy: use prop if provided, otherwise derive from answer
        const accuracy = props.accuracy ?? getDecimalPlaces(props.answer);
        // If accuracy is 0, keep as integer; otherwise round to that many places
        const roundTo = (x, dp) => Number(Math.round(`${x}e${dp}`) + `e-${dp}`);
        value = accuracy === 0 ? Math.trunc(n) : roundTo(n, accuracy);
      }
    }
    props.onChange({
      id: props.id,
      value,
      answer: props.answer,
      numberOfInputs: props.numberOfInputs,
      feedback: props.feedback,
      unique: props.unique,
    });
  };
  const onChange = (event) => {
    let value = null;
    if (props.type === INPUT_TYPES.TEXT) {
      value = event.target.value;
    }
    if (props.type === INPUT_TYPES.NUMBER) {
      value = event.target.valueAsNumber;
    }
    props.onChange({
      id: props.id,
      value,
      answer: props.answer,
      numberOfInputs: props.numberOfInputs,
      unique: props.unique,
      feedback: props.feedback,
    });
  };

  const setClassName = () => {
    let className = props.className;
    if (props.showFeedback) {
      className += ` ${props.isCorrect ? "correctOption" : "incorrectOption"}`;
    }
    return className;
  };

  const getDecimalPlaces = (val) => {
    if (val === null || val === undefined || val === "") return 0;
    const s = String(val).trim();

    if (/e/i.test(s)) {
      const n = Number(s);
      if (!isFinite(n)) return 0;
      const parts = String(n).split(".");
      return parts[1] ? parts[1].length : 0;
    }

    const dot = s.indexOf(".");
    return dot === -1 ? 0 : s.length - dot - 1;
  };

  const stepFromAnswer = (answer, maxPlaces = 6) => {
    const dp = Math.min(getDecimalPlaces(answer), maxPlaces);
    return dp <= 0 ? 1 : 1 / Math.pow(10, dp);
  };

  return (
    <td className={setClassName()} colspan={props.colspan}>
      <div className={`dataTable_row_cell_contents`}>
        <input
          placeholder={props.placeholder}
          className={`${props.className}_input`}
          type={props.type}
          value={
            (props.type === INPUT_TYPES.NUMBER && !isNaN(props.value)) ||
            props.type !== INPUT_TYPES.NUMBER
              ? props.value
              : null
          }
          step={
            props.type === INPUT_TYPES.NUMBER
              ? stepFromAnswer(props.answer)
              : undefined
          }
          onBlur={validate}
          onChange={onChange}
          disabled={props.disabled}
          pattern={props.type == "number" ? "^([-+,0-9.]+)" : null}
          onWheel={(e) => e.target.blur()}
        />
        <FeedbackIcon
          isSuccess={props.isCorrect}
          showFeedback={props.showFeedback}
          className={`${props.className}_feedback`}
          feedback={props.feedback}
        />
      </div>
    </td>
  );
}

InputCell.propTypes = {
  /**
   * Unique id for the cell
   */
  id: PropTypes.string,
  /**
   * Placehodler for the cell
   */
  placeholder: PropTypes.string,
  /*
   * className to be set on component
   */
  className: PropTypes.string,
  /**
   * value to display on input
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * type of the input
   */
  type: PropTypes.oneOf(["text", "number"]),
  /**
   * Boolean feedback on value being correct/incorrect
   */
  isCorrect: PropTypes.bool,
  /**
   * Boolean to check if answer value is unique in table
   */
  unique: PropTypes.bool,
};
